import Axios from "axios";
import {
    SET_PUR_ORDER_LIST,
    UNSET_PUR_ORDER_LIST,
  } from "@/store/mutation-types";
import {saveUpdatePurOrder, getPurOrderList, getPurOrderById as getPurOrderByIdApi } from "@/store/api";
// initial state
const state = {
  getPurOrderList: [],
  editingPurOrder: null,
};

const getters = {
  getPurOrderList(state) {
    return state.getPurOrderList;
  },
};

const mutations = {
  [SET_PUR_ORDER_LIST](state, data) {
    state.getPurOrderList = data;
  },
  [UNSET_PUR_ORDER_LIST](state) {
    state.getPurOrderList = [];
  },
  setEditingPrOrder(state, requisition) {
    state.editingPurOrder = requisition;
  },
};

const actions = {
  saveUpdatePurOrder({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdatePurOrder, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getPurOrderList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getPurOrderList, data)
        .then(function (response) {
          commit('SET_PUR_ORDER_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PUR_ORDER_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getPurOrderById({ commit }, id) {
    const getPurOrderById = `${getPurOrderByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getPurOrderById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
